// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderDetailsProblematicPaymentButton_button__3JDAq"};